<template>
  <div class="patent-certificate">
    <div class="title">{{ $theme ? "发明专利" : "PATENTS" }}</div>
    <div class="line"></div>
    <div class="subtitle">{{
        $theme ? "被多家世界500强企业有偿使用的专利证明了汉熵研发的前瞻性和经济价值" : "The patents used by many Fortune 500 companies prove the forward-looking and economic value of Hanentropy research and development"
      }}
    </div>
    <div class="patent-certificate-main">
      <div class="patent-left">
        <img :src="`/image/brand-honor/patent/专利证书${active}.png`"/>
      </div>
      <div class="patent-right">
        <div class="patent-right-top">
          <img
              v-for="item in list.filter(({id})=>id<3)"
              :key="item.id"
              :class="`img${item.id}${active === item.id?' img-active':''}`"
              :src="`/image/brand-honor/patent/专利证书${item.id}-1.png`"
              @click="active = item.id"
          />
        </div>
        <div class="patent-right-bottom">
          <img
              v-for="item in list.filter(({id})=>id>2)"
              :key="item.id"
              :class="`img${item.id}${active === item.id?' img-active':''}`"
              :src="`/image/brand-honor/patent/专利证书${item.id}-1.png`"
              @click="active = item.id"
          />
        </div>
      </div>
    </div>
<!--    <div class="patent-certificate-name">-->
<!--      <span>{{ activeName }}</span>-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  name: 'CoreTechnology',
  components: {},
  data() {
    return {
      active: 1,
      list: [
        {
          id: 1,
          name: '汉熵北京专利墙',
          nameEng: "AIoT Entropy Beijing patent wall"
        },
        {
          id: 2,
          name: "自主创新专利墙",
          nameEng: "Independent innovation patent wall"
        },
        {
          id: 3,
          name: "专利证书",
          nameEng: "Patent certificate"
        },
        {
          id: 4,
          name: "美国专利证书",
          nameEng: "United States patent certificate"
        },
        {
          id: 5,
          name: "中国专利证书",
          nameEng: "Chinese patent certificate"
        }
      ]
    }
  },
  computed: {
    activeName() {
      const obj = this.list.find(({id}) => id === this.active)
      return this.$theme ? obj.name : obj.nameEng
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
@import './Index.scss';
</style>
